import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { getAllNews, getNewsItem, getPageNews,
  getSimilarNewsItem, page } from '@/services/api';
import { IPageNewsTranslation } from '@/types';
import router from '@/router';

const CLEAR_NEWS_ITEM = 'CLEAR_NEWS_ITEM';
const GET_NEWS_ITEM = 'GET_NEWS_ITEM';
const GET_SIMILAR_NEWS_ITEM = 'GET_SIMILAR_NEWS_ITEM';
const SET_NEWS_ALL = 'SET_NEWS_ALL';
const SET_NEWS_TRANSLATION = 'SET_NEWS_TRANSLATION';
const SET_NEXT_PAGE = 'SET_NEXT_PAGE';

const rawError: boolean = true;

@Module({namespaced: true})
export default class NewsPage extends VuexModule {
  public translation: any = {
    titlePage: '',
    headerBgImg: {},
    filers: {},
    promo_text: '',
    pagination_btn_text: '',
    similar_title: '',
    similar_link_text: '',
  };
  public news: any = {};
  public newsById: any = {};
  public similarNews: any = {};

  public get translations(): {} {
    return this.translation;
  }

  public get titlePage(): {} {
    return this.translation.headerBgImg.title;
  }

  public get headerBgImg(): {} {
    return this.translation.headerBgImg.image;
  }

  public get filters(): {} {
    return this.translation.filters;
  }

  public get paginationBtnText(): {} {
    return this.translation.pagination_btn_text;
  }

  public get promoText(): {} {
    return this.translation.promo_text;
  }

  public get allNews(): {} {
    return this.news;
  }

  public get newsItem(): {} {
    return this.newsById;
  }

  public get similarTitle(): {} {
    return this.translation.similar_title;
  }

  public get similarLinkText(): {} {
    return this.translation.similar_link_text;
  }

  public get similarNewsItems(): {} {
    return this.similarNews;
  }

  @Mutation
  public [SET_NEWS_TRANSLATION](payload: IPageNewsTranslation): void {
    this.translation = payload;
  }

  @Mutation
  public [SET_NEWS_ALL](payload): void {
    this.news = payload;
  }

  @Mutation
  public [SET_NEXT_PAGE](payload): void {
    const actualResults = this.news.results.concat(payload.results);
    this.news = payload;
    this.news.results = actualResults;
  }

  @Mutation
  public [GET_NEWS_ITEM](payload): void {
    this.newsById = payload;
  }

  @Mutation
  public [CLEAR_NEWS_ITEM](): void {
    this.newsById = {};
    this.similarNews = {};
  }

  @Mutation
  public [GET_SIMILAR_NEWS_ITEM](payload): void {
    this.similarNews = payload;
  }

  @Action({commit: SET_NEWS_TRANSLATION, rawError})
  public async fetchTranslation() {
    const data = await page('news');
    return data ? data : this.translation;
  }

  @Action({commit: SET_NEWS_ALL, rawError})
  public async fetchNews() {
    const response = await getAllNews();
    return response.status === 200 ? response.data : this.news;
  }

  @Action({commit: SET_NEWS_ALL, rawError})
  public async getNewPage(query) {
    const response = await getPageNews(query);
    return response ? response.data : this.news;
  }

  @Action({commit: SET_NEXT_PAGE, rawError})
  public async getNextPage(query) {
    const oldNews = {...this.news};
    oldNews.results = [];
    const response = await getPageNews(query);
    return response?.status === 200 ? response.data : {...oldNews, ...response};
  }

  @Action({commit: GET_NEWS_ITEM, rawError})
  public async getNewsById(id) {
    const response = await getNewsItem(id);
    if (response.status === 200) {
      return response.data;
    } else {
      router.push({name: 'pageNotFound'});
      return {};
    }
  }

  @Action({commit: GET_SIMILAR_NEWS_ITEM, rawError})
  public async getSimilarNewsById(id) {
    const response = await getSimilarNewsItem(id);
    return response.status === 200 ? response.data : this.similarNews;
  }

  @Action({commit: CLEAR_NEWS_ITEM, rawError})
  public async clearNewsItem() {}

}
